export const COREVO_CLIENT_ID = -1;
export const COREVO_CLIENT_NAME = "CorEvo Solutions";

export const REMINDER_RENEW_AUTHORIZATION = "RENEW_AUTHORIZATION";
export const REMINDER_RENEW_COUPON_STAMP = "RENEW_COUPON_STAMP";
export const REMINDER_RENEW_COUPON = "RENEW_COUPON";

export const REMINDER_RENEW_CERTIFICATE = "RENEW_CERTIFICATE";

export const CALENDAR_EVENT_TYPE_REMINDER = 'reminder';
export const CALENDAR_EVENT_TYPE_RSVTITASK = 'rsvti-task';

export const AuthzIscirAFCode = {
    OperatorRSVTI: 'aa_27'
}

export const EntityType = {
    User: 'user',
    UserSubcontractor: 'user-subcon',
    AuthzIscir: 'authziscir',
    AuthzIntern: 'authzinternal'
}

export const EeAuthzType = {
    Iscir: 'AA_ISCIR',
    Internal: 'AA_INTERN'
}

export const RoleSystem = {
    Admin: 'ROLE_SYSTEM_ADMIN',
    User: 'ROLE_SYSTEM_USER'
}

export const ClientType = {
    ServicuExtern: 'se',
    Angajator: 'an'
}

export const ServiceType = {
    Internal: 'INTERNAL',
    External: 'EXTERNAL'
}

export const RoleClient = {
    Admin: 'ROLE_CLIENT_ADMIN',
    User: 'ROLE_CLIENT_USER',
    UserSpecificEmployer: 'ROLE_CLIENT_USER_RESTRICTED'
}

export const RoleSubcontractor = {
    UserSubcon: 'ROLE_CLIENT_USER_SUBCON',
    ClientSubcon: 'ROLE_CLIENT_SUBCON'
}

export const SubcontractorService = {
    RSVTI: 'RSVTI',
    LaborProtection: 'LABOR_PROTECTION',
    PSI: 'PSI'
}

export const TaskType = {
    CouponStampRenewal: 'COUPON_STAMP_RENEWAL',
    CouponCourseScheduling: 'COUPON_COURSE_SCHEDULING',
    CertificateRenewal: 'CERTIFICATE_RENEWAL'
}

export const TaskStatus = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
}

export const TaskExamStatus = {
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Absent: 'ABSENT'
}

export const DocAuthzIscir = {
    PvTraining: 'PV_TRAINING',
    PvResults: 'PV_RESULTS'
}

export const DocAuthzInternal = {
    CertificateAll: 'CERTIFICATE_ALL',
    Certificate: 'CERTIFICATE',
    CertificateThT: 'CERTIFICATE_TT', 
    CertificatePrT: 'CERTIFICATE_PT', 
    PvResults: 'PV_RESULTS'
}


export const ExamType = {
    CouponRenewal: 'COUPON_RENEWAL',
    AuthorizationRenewal: 'AUTHZ_RENEWAL'
}

export const ContractMuncaStatus = {
    Activ: 'CIMA',
    Inchis: 'CIMI',
    Suspendat: 'CIMS',
    ConcediuMedical: 'CMB',
    ConcediuIngrijireCopil: 'CIC'
}

export const AuthzStatus = {
    Active: 'Active',
    Suspended: 'Suspended',
    NotUsed: 'NotUsed'
}

export const CourseRegistrationStatus = {
    Registered: 'Registered',
    CertificateIssued: 'CertificateIssued',
    Completed: 'Completed'
}

export const AuthzIscirImageType = {
    Authz: 'AUTHZ_IMG',
    Coupon: 'TALON_IMG'
}